import _ from "lodash";
import DiagramUtils from "../utils/DiagramUtils";


export default class PluginDragAdd {


    constructor(designer, {
    } = {}) {

        this.designer = designer;
    }

    install() {

        if (this.designer.mode === "view")
            return;

        const dom = this.designer.dom;
        dom.addEventListener("dragenter", this.onDragEnterHandler = this.onDragEnter.bind(this));
        dom.addEventListener("dragover", this.onDragOverHandler = this.onDragOver.bind(this));
        dom.addEventListener("drop", this.onDropHandler = this.onDrop.bind(this));
    }

    uninstall() {

        if (this.designer.mode === "view")
            return;

        const dom = this.designer.dom;
        dom.removeEventListener("dragenter", this.onDragEnterHandler);
        dom.removeEventListener("dragover", this.onDragOverHandler);
        dom.removeEventListener("drop", this.onDropHandler);
    }

    onDragEnter(e) {
        e.dataTransfer.dropEffect = 'copy';
        e.preventDefault();
    }

    onDragOver(e) {
        e.dataTransfer.dropEffect = 'copy';
        e.preventDefault();
    }

    onDrop(e) {
        e.preventDefault();
        let model = e.dataTransfer.getData("diagram");
        if (!model)
            return;

        model = JSON.parse(model);
        const diagrams = DiagramUtils.diagrams;
        const modelInfo = diagrams[model.type];
        if (!modelInfo)
            return;

        let pt = this.designer.absoluteScreenPointToView({ x: e.clientX, y: e.clientY });
        model.model.x = Math.round(pt.x - model.model.width.value / 2);
        model.model.y = Math.round(pt.y - model.model.height.value / 2);

        let maxItem = _.maxBy(this.designer.diagrams, c => c.zIndex);
        if (maxItem)
            model.model.zIndex = maxItem.zIndex;

        model = new modelInfo.model(model.model);
        model.setRandomId();
        this.designer.addModel(model, true);
    }
}